import gql from "graphql-tag";

export const createOrganization = gql`
  mutation CreateOrganization($data: OrganizationCreateInput!) {
    createOrganization(data: $data){
      id
      createdAt
    }
  }
`;